import trend from 'jquery-trend';
import themeUtils from '../themeUtils';

export default class Modal {
  constructor(component = {}) {
    this.$el = $(component.el);
    this.$body = $(document.body);
    this.$window = $(window);
    this.$modalInner = this.$el.find('[data-modal-inner]');
    this.$contents = this.$el.find('[data-modal-contents]');
    this.mobileFriendly = (this.$el.attr('data-modal-mobile-friendly') != null);

    this.$body.on('click', () => this.close);
    $('[data-modal-close]').on('click', () => this.close());

    this.selectors = {
      open: 'modal-opened',
      visible: 'modal-visible',
      active: 'modal-active',
      scrollLock: 'scroll-locked',
    };

    const defaultCallbacks = {
      onOpen: () => ({}),
      onClose: () => ({}),
    };

    this.callbacks = $.extend({}, defaultCallbacks, component.callbacks);
  }

  // Manually open a modal.
  open() {
    this.$el.addClass(this.selectors.open);
    this.$window.on('resize.modal', () => this._resize());

    // Use onOpen to insert contents into modal
    return this.callbacks.onOpen({
      $modal: this.$el,
      $contents: this.$contents,
    });
  }

  // Close modal, and clean up
  close() {
    this.$el.removeClass(this.selectors.active)
      .removeClass(this.selectors.visible)
      .removeClass(this.selectors.open);

    this.$body.removeClass(this.selectors.scrollLock);

    this.$contents.html('');

    this.callbacks.onClose();
    this.$window.off('resize.modal');
  }

  /*
            Make a modal visible after content has been added
            */
  showModal() {
    this.$body.addClass(this.selectors.scrollLock);

    this._position();

    return this.$el.addClass(this.selectors.visible).one('trend', () => this.$el.addClass(this.selectors.active));
  }

  _resize() {
    this._position();

    // Some modals shouldn't be visible on mobile
    if (!this.mobileFriendly) {
      const windowWidth = themeUtils.windowWidth();
      if (windowWidth > themeUtils.breakpoints.small) { return; }
      this.close();
    }
  }

  /*
            Center modal vertically and horizontally
            */
  _position() {
    return this.$modalInner.css({
      marginTop: -(this.$modalInner.outerHeight() / 2),
      marginLeft: -(this.$modalInner.outerWidth() / 2),
    });
  }
}
